import toast from "react-hot-toast";
import { postBanner } from '../api/banner';
import React, { useState, useEffect } from 'react';
import { useProjectStore } from '../store/useProjectStore';
import Loader from "./Loader";

const BannerPage = ({ pageName }) => {
    const [data, setData] = useState({
        subTitle: '',
        title: '',
        image: null,
        description: '',
        buttonText: '',
    });
    let [loading, setLoading] = useState(false)
    let [loading1, setLoading1] = useState(false)
    let { getBanner, banner } = useProjectStore();

    const handleSubmit = async () => {

        if (!pageName) {
            toast.error("page name is not define");
            return
        }
        setLoading(true)
        await postBanner(data, pageName)
        setLoading(false)
    };

    const getBannerFunction = async () => {
        setLoading(true)
        setLoading1(true)
        let res = await getBanner(pageName);
        setData({ ...data, ...res });
        setLoading(false)
        setLoading1(false)
    };

    const getImageSrc = (img) => {
        if (!img) return null;
        if (typeof img === "string") {
            return img;
        }
        return URL.createObjectURL(img);
    };

    useEffect(() => {
        getBannerFunction();
    }, []);

    return (
        <div className="mb-6 space-y-6 bg-white">
            <div className="border border-neutral-200 rounded-md p-4">
                <h4 className="mb-3">Banner Section</h4>
                <Loader loading={loading1}>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm text-neutral-700 mb-1">Heading</label>
                            <input
                                type="text"
                                value={data?.title}
                                onChange={(e) => setData({ ...data, title: e.target.value })}
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                        </div>
                        <div>
                            <label className="block text-sm text-neutral-700 mb-1">Subheading</label>
                            <input
                                type="text"
                                value={data?.subTitle}
                                onChange={(e) => setData({ ...data, subTitle: e.target.value })}
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                        </div>
                        <div>
                            <label className="block text-sm text-neutral-700 mb-1">Button Text</label>
                            <input
                                type="text"
                                value={data?.buttonText}
                                onChange={(e) => setData({ ...data, buttonText: e.target.value })}
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                        </div>
                        <div>
                            <label className="block text-sm text-neutral-700 mb-1">
                                Background Image
                            </label>
                            <div className="flex items-center">
                                <div className="w-24 h-16 bg-neutral-600 flex items-center justify-center text-white text-xs mr-4">
                                    {getImageSrc(data?.image) ? (
                                        <img
                                            src={getImageSrc(data?.image)}
                                            alt="Hero"
                                            className="w-full h-full object-cover"
                                        />
                                    ) : (
                                        'No Image'
                                    )}
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) =>
                                        setData({ ...data, image: e.target.files[0] })
                                    }
                                    className="hidden"
                                    id="bannerImage"
                                />
                                <div>
                                    <span className='d-block text-sm font-medium text-gray-700'>Recomended Image Size : 1920px*1080px</span>
                              <br/>
                              <br/>
                                <label
                                    htmlFor="bannerImage"
                                    className="d-block px-3 py-1 border border-neutral-300 rounded-md text-sm cursor-pointer"
                                >
                                    Change Image
                                </label>
                                  </div>
                            </div>
                        </div>
                        <div>
                            <h4 className="mb-3">Description</h4>
                            <div>
                                <textarea
                                    rows="4"
                                    value={data?.description}
                                    onChange={(e) =>
                                        setData({ ...data, description: e.target.value })
                                    }
                                    className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                                />
                            </div>
                        </div>
                        <div className="flex justify-end items-center mb-6">
                            <button
                                className="bg-neutral-900 text-white px-4 py-2 rounded-md text-sm flex items-center"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? (
                                    <div className="flex items-center gap-2">
                                        <svg
                                            className="animate-spin h-5 w-5 text-white"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"
                                            ></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                            ></path>
                                        </svg>
                                        Processing...
                                    </div>
                                ) : (
                                    <>
                                        <i className="fa-solid fa-plus mr-2"></i>
                                        Submit banner
                                    </>
                                )}
                            </button>
                        </div>


                    </div>
                </Loader>
            </div >
        </div >
    );
};

export default BannerPage;
